import { Spinner } from '@/components/ui/Spinner'
import { ROUTES } from '@/constants/routes'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { Navigate, useLocation } from 'react-router-dom'

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 */
export function ProtectedRoute({ children }) {
  const location = useLocation()
  const { isAuthenticated, isLoading, error } = useAuth()

  // Show loading spinner while checking auth
  if (isLoading) {
    return <Spinner fullScreen />
  }

  // If there's an error checking auth, treat as not authenticated
  // (API might be down, or session expired)
  if (!isAuthenticated || error) {
    // Redirect to login, preserving the attempted location
    return <Navigate to={ ROUTES.LOGIN } state={ { from: location } } replace />
  }

  return children
}

export default ProtectedRoute
